import { Exception } from 'exceptions';

import loggerAPI from './plugins/logger';
import historyAPI from './plugins/history';
import cookieAPI from './plugins/cookie';

//=============================================================
// Utils
//=============================================================

export function boot(API, callback) {

	if(typeof API !== 'object')
		throw Exception('Invalid API object');

	if(typeof API.name !== 'string')
		throw Exception('Invalid API name');

	const { name } = API;

	global[name] = API || {}

	// Some boot porcesses, maybe run module boot registrations and execute here?

	if(typeof callback === 'function')
		callback();

}

//=============================================================
// Factory
//=============================================================

export function create(name, config) {

	const _config = config || {};
	const _instances = [];

	class API {

		constructor() {
			this.name = name;
		}

		/**
    * Config
    */
		config(...args) {

			let path = args;

			if(args.length === 1) {

				if(typeof args[0] === 'string')
					path = args[0].split('.');

				else if(args[0] instanceof Array)
					path = args[0];
			}

			const get = (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o);

			return args.length ? get(path, _config) : _config;
		}

		/**
    * Registrar methods
    */

		use(plugin) {

			if (plugin.installed) {
				console.warn('Druplicate plugin initialization');
				return;
			}

			plugin.call(null, this);
			plugin.installed = true;

			return this;
		}

		/**
    * Instance methods
    */

		registerInstance(name, object) {

			return _instances[name] = object;
		}

		getInstance(name = null) {

			if(name === null)
				return _instances;

			const instance = _instances[name];
			if(typeof instance === 'undefined')
				throw new Exception(`Invalid instance '${name}'`);

			return instance;
		}
	}

	const apiObject = new API();

	// Register plugins
	apiObject.use(loggerAPI);
	apiObject.use(historyAPI);
	apiObject.use(cookieAPI);
	// apiObject.use(tasksAPI);

	return apiObject;
}
